export default __webpack_public_path__ + "static/media/property_606.5ac03738.png";